import React from "react";
import styled from "styled-components";
import { colors } from "utils";

// The neutral "Tag - Level/Small" variant (Figma 3847-38168) shown wherever a group's
// question set carries an applied Advanced Selection filter — group cards, the Assign
// Groups distribution modal, etc. One declaration, reused everywhere.
const Tag = styled.span`
  align-items: center;
  align-self: flex-start;
  background-color: #f2f2f2;
  border: 1px solid #acafad;
  border-radius: 11px;
  color: ${colors.nightlyWoods500};
  display: inline-flex;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  justify-content: center;
  line-height: 20px;
  padding: 2px 8px;
  white-space: nowrap;
`;

export const CustomizedTag = (props) => <Tag {...props}>Customized</Tag>;
